import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Grid } from "@material-ui/core";
import DownloadIcon from "@material-ui/icons/GetApp";
import { CSVLink } from "react-csv";
import { Alert } from "@material-ui/lab";
import PaperedInput from "../../../components/Inputs/PaperedInput";
import { debounce } from "../../../utils/functions";
import voucherApi from "../../../api/voucher-api";

const formatVoucherDate = date => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString("en-GB");
};

const formatDisplayAmount = amount => {
  const formatted = Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return `₦${formatted}`;
};

const VoucherRedemption = ({ jwt }) => {
  const [page, setPage] = useState(0);
  const [error, setError] = useState({
    isError: false,
    message: ""
  });
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [voucherData, setVoucherData] = useState([]);

  useEffect(() => {
    setLoading(true);
    setError({ isError: false, message: "" });

    voucherApi
      .getVoucherRedemptions(jwt, page + 1, searchInput)
      .then(res => {
        const { data, pagination } = res.data;
        setTotalData(pagination.totalCount);
        const mappedData = data.map((item, index) => ({
          voucherCode: item.voucher_code,
          guestName: item.guest_name,
          email: item.guest_email,
          itemsRedeemed: item.items_redeemed,
          voucherValue: formatDisplayAmount(item.voucher_value),
          balancePaymentMade: formatDisplayAmount(item.balance_payment_made),
          date: formatVoucherDate(item.redemption_date),
          id: item.transaction_ref || index
        }));
        console.log("Mapped data", mappedData);
        setVoucherData(mappedData);
        setLoading(false);
      })
      .catch(err => {
        setError({ isError: true, message: "There is an error loading data" });
        setLoading(false);
      });
  }, [jwt, page, searchInput]);

  const columns = [
    { field: "voucherCode", headerName: "Voucher Code", width: 150 },
    { field: "guestName", headerName: "Guest Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "itemsRedeemed", headerName: "Items Redeemed", width: 200 },
    { field: "voucherValue", headerName: "Voucher Value", width: 200 },
    {
      field: "balancePaymentMade",
      headerName: "Balance Payment Made",
      width: 200
    },
    { field: "date", headerName: "Date Added ", width: 200 }
  ];

  return (
    <div>
      <>
        <Grid container alignItems="center" justify="space-between">
          <Grid item xs={6}>
            <PaperedInput
              onChange={e => {
                e.persist();
                debounce(() => setSearchInput(e.target.value), 2000);
              }}
              placeholder="Search for User"
            />
          </Grid>
          <Grid item xs={6}>
            <Grid justify="flex-end" container>
              <CSVLink data={voucherData} filename={"voucher-redemptions.csv"}>
                <Button variant="contained" color="primary">
                  <DownloadIcon className="c-user-icon" /> DOWNLOAD CSV
                </Button>
              </CSVLink>
            </Grid>
          </Grid>
        </Grid>
        <div style={{ height: "90vh", width: "100%", marginTop: "20px" }}>
          {error.isError ? (
            <Alert severity="error">{error.message}</Alert>
          ) : (
            <DataGrid
              rows={voucherData}
              columns={columns}
              pageSize={10}
              rowHeight={50}
              headerHeight={60}
              disableColumnMenu={true}
              autoHeight={true}
              loading={loading}
              rowCount={totalData}
              page={page}
              onPageChange={page => {
                setPage(page);
              }}
              paginationMode="server"
            />
          )}
        </div>
      </>
    </div>
  );
};

const mapStateToProps = state => ({
  jwt: state.user.user.jwt
});

export default connect(mapStateToProps)(withRouter(VoucherRedemption));
